import secureLocalStorage from 'react-secure-storage';

interface Tenant {
  cid: number;
  tenantId: string;
  roleId: string;
  instanceName?: string;
  instanceId?: string;
  companyId?: string;
}

const isDebug = process.env.REACT_APP_SECURE_LOCAL_STORAGE_ENABLE === 'false';
const storage = isDebug ? localStorage : secureLocalStorage;

export function getCurrentCid(): number {
  const hash = window.location.hash;
  return +hash.replace('#', '').replace('cid=', '');
}

export function getAllTenants(): Tenant[] {
  return (JSON.parse((storage.getItem('tenants') as string) || '[]') || []) as Tenant[];
}

export function getTenantById(cid: number = getCurrentCid()): Tenant | undefined {
  return getAllTenants().find((t) => t.cid === cid);
}

export function getRoleId(cid: number = getCurrentCid()): string | undefined {
  return getTenantById(cid)?.roleId;
}

export function getTenantId(cid: number = getCurrentCid()): string {
  return getTenantById(cid)?.tenantId ?? '';
}
